'use strict';

import Vue from 'vue';
import VueI18n from 'vue-i18n';
import moment from 'moment';


Vue.use(VueI18n);

// load default locale
const DEFAULT_LOCALE = 'en';
import message from '@/assets/i18n/en.json';
moment.locale([DEFAULT_LOCALE]);

//=================================================================================================================

export const langs = [
	{ code: 'fr', flag: '🇫🇷', text: 'Français' },
	{ code: 'en', flag: '🇬🇧', text: 'English' },
];

//=================================================================================================================

export const i18n = new VueI18n({
	locale: DEFAULT_LOCALE,
	fallbackLocale: DEFAULT_LOCALE,
	silentFallbackWarn: true,
	messages: { [DEFAULT_LOCALE]: message }
});

//=================================================================================================================

const loadedLanguages = [DEFAULT_LOCALE];

export const loadLanguage = async lang => {
	// requested lang is already the current locale
	if (i18n.locale === lang) { return }

	// requested lang is not available
	const isLangAvailable = langs.find(l => l.code === lang);
	if (!isLangAvailable) { return }

	// load locale if needed
	if (!loadedLanguages.includes(lang)) {
		const message = await import(/* webpackChunkName: "i18n-[request]" */ `@/assets/i18n/${lang}.json`);
		i18n.setLocaleMessage(lang, message);
		loadedLanguages.push(lang);
	}

	// set locale globally
	i18n.locale = lang;
	moment.locale(lang);
};


// load user's preferred language
loadLanguage(window.navigator.language.split('-')[0]);
